import { fsLogger } from './fullstory';

const WARNING = 'warning';
const ERROR = 'error';
const DEFAULT = 'default';

const { STOP_ALL_LOGGERS = 'continue' } = process.env;
const { ENVIRONMENT = 'production' } = process.env;

function log(type, message) {
  switch (type) {
    case ERROR:
      console.error(message);
      break;
    case WARNING:
      console.warn(message);
      break;
    case DEFAULT:
    default:
      console.log(message);
      break;
  }
}

function convertDataToString(data, dataLenght) {
  if (!data) return 'Empty';
  if (typeof data === 'string') return dataLenght ? data.substring(0, dataLenght) : data;
  const dataString = JSON.stringify(data);
  return dataLenght ? dataString.substring(0, dataLenght) : dataString;
}

function getMessageLogger(title, subtitle, data, timeDate) {
  const cleanSubtitle = subtitle ? `${subtitle}:\n` : '';
  const message = `${timeDate} \n${title}\n${cleanSubtitle} \t${data}`;
  return message;
}

function createTimeDate() {
  const td = new Date();
  const hours = td.getHours().toString().padStart(2, '0');
  const minutes = td.getMinutes().toString().padStart(2, '0');
  const seconds = td.getSeconds().toString().padStart(2, '0');
  return `${td.getDate()}/${td.getMonth()}/${td.getFullYear()} ${hours}:${minutes}:${seconds}`;
}

export function createMessageLogger(title, subtitle, data, dataLenght) {
  const timeDate = createTimeDate();
  const stringData = convertDataToString(data, dataLenght);
  const message = getMessageLogger(title, subtitle, stringData, timeDate);
  return message;
}

function logger({
  title, subtitle = '', data = null, dataLenght = 0, type = 'default',
}) {
  try {
    if (STOP_ALL_LOGGERS === 'stop') return;
    const message = createMessageLogger(title, subtitle, data, dataLenght);
    if (ENVIRONMENT === 'production') fsLogger(message);
    else {
      log(type, message);
    }
  } catch (e) {
    console.error(e);
  }
}

export default logger;
